import { render } from "./SmartMatchPackageHint.vue?vue&type=template&id=2a6c6a0a"
import script from "./SmartMatchPackageHint.vue?vue&type=script&lang=js"
export * from "./SmartMatchPackageHint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__